import PropTypes from "prop-types";
import React from "react";

import { DialogActions, DialogContent } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import PrimaryButton from "../../UI/Buttons/PrimaryButton";
import SecondaryButton from "../../UI/Buttons/SecondaryButton";

import modalStyles from "../../../style/modal";
import textStyle from "../../../style/typography";

function DeleteModal({
  deleteMethod,
  open,
  onClose,
  details,
  isLoading,
  hasTitle,
  title,
}) {
  const textClasses = textStyle();
  const modalClasses = modalStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="delete-dialog"
      fullWidth={true}
      maxWidth="xs"
    >
      <DialogTitle
        className={`${textClasses.modalHeader} ${textClasses.modalHeadWrap}`}
        id="delete-dialog-title"
      >
        {details?.title}
      </DialogTitle>
      <DialogContent className={modalClasses.modalContent}>
        {details?.description}
      </DialogContent>
      <DialogActions className={modalClasses.modalFooter}>
        <SecondaryButton onClick={onClose}>Cancel</SecondaryButton>
        <PrimaryButton
          hideIcon={true}
          onClick={deleteMethod}
          disabled={isLoading}
        >
          {hasTitle ? title : `Delete`}
        </PrimaryButton>
      </DialogActions>
    </Dialog>
  );
}

DeleteModal.propTypes = {
  deleteMethod: PropTypes.func,
  open: PropTypes.bool,
  isLoading: PropTypes.bool,
  onClose: PropTypes.func,
  details: PropTypes.shape({
    title: PropTypes.any,
    description: PropTypes.any,
  }),
};

export default DeleteModal;
